import _ from 'lodash'
import { OktaAuth } from '@okta/okta-auth-js'
import { AmplifyConfigurationPayloadType } from '../cognito/amplifyConfiguration'

export enum OktaSignFlow {
  logIn = 'logIn',
  signUp = 'signUp',
}

type RelayStateProperties = {
  flow: OktaSignFlow
  redirect_url?: string
}

/**
 * @param configuration {AmplifyConfigurationPayloadType}
 * @param state {RelayStateProperties}
 */
export const signIn = async (
  configuration: AmplifyConfigurationPayloadType,
  state?: RelayStateProperties
) => {
  const { oktaConfiguration } = configuration
  if (!oktaConfiguration) {
    return
  }

  const redirectUri = `${window.location.origin}/login/callback`
  const { idp, clientId, metadataUrl } = oktaConfiguration

  // getting metadata from metadata url
  const res = await fetch(metadataUrl, {
    method: 'GET',
  })

  if (res.ok) {
    const payload = await res.json()
    const metadata = _.assign(
      {
        idp,
        clientId,
        redirectUri,
        state: JSON.stringify(state),
        pkce: true,
        responseType: 'token',
        scopes: ['openid', 'email', 'profile'],
      },
      payload
    )

    const okta = new OktaAuth(metadata)
    await okta.signInWithRedirect(metadata)
  }
}
